import { React, useState, useEffect } from 'react'
import { Box, Typography, Skeleton } from '@mui/material'
import EntitlementCircularProgress from './entitlementCircularProgress'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'

const BalanceTypeReplacement = ({ item }) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 1000)
  }, [])

  const creditUsed = item?.leave_credit?.amount - item?.leave_credit?.balance

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 35px - 70px - 50px)',
      }}
    >
      <Box
        sx={{
          py: 2,
          px: { xs: 1.5, lg: 6.25 },
          flex: 1,
        }}
      >
        <Box
          sx={{
            py: 2,
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            alignItems: 'center',
            columnGap: { xs: 0.5, lg: 5 },
            rowGap: { xs: 3, lg: 0 },
          }}
        >
          {isLoading ? (
            <Box>
              <Skeleton variant="circular" width={120} height={120} />
            </Box>
          ) : (
            <EntitlementCircularProgress
              balance={item?.leave_credit?.balance}
              total={item?.leave_credit?.amount}
            />
          )}
          <Box width={3 / 4} display="flex" flexDirection="column" rowGap={1}>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                alignItems: 'center',
                px: 1.5,
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="body1" color="light-gray-text.main">
                Replacement Credit credited
              </Typography>
              {isLoading ? (
                <Box width={'30%'}>
                  <Skeleton />
                </Box>
              ) : (
                <Typography variant="body1" color="dark-text.main">
                  {item.leave_credit.amount
                    ? item.leave_credit.amount > 1
                      ? `${item.leave_credit.amount} days`
                      : `${item.leave_credit.amount} day`
                    : '0 day'}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                px: 1.5,
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="body1" color="light-gray-text.main">
                Replacement Credit used
              </Typography>
              {isLoading ? (
                <Box width={'30%'}>
                  <Skeleton />
                </Box>
              ) : (
                <Typography variant="body1" color="dark-text.main">
                  {creditUsed
                    ? creditUsed === 1
                      ? `${creditUsed} day`
                      : `${creditUsed} days`
                    : '0 day'}
                </Typography>
              )}
            </Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: 'gray-background.main',
                borderRadius: 1.1,
                py: 1.25,
                px: 1.5,
              }}
            >
              <Typography variant="body1" color="dark-text.main">
                Effective balance
              </Typography>
              {isLoading ? (
                <Box width={'30%'}>
                  <Skeleton />
                </Box>
              ) : (
                <Typography variant="body1" color="alternate.main" sx={{ fontWeight: 'bolder' }}>
                  {item.leave_credit.amount - creditUsed
                    ? item.leave_credit.amount - creditUsed === 1
                      ? `${item.leave_credit.amount - creditUsed} day`
                      : `${item.leave_credit.amount - creditUsed} days`
                    : '0 day'}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            rowGap: 1.5,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'gray-background.main',
              width: '100%',
              py: 0.5,
              px: 1.75,
              my: 2,
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" color="light-gray-text.main">
              Replacement credit info
            </Typography>
          </Box>
          {isLoading ? (
            <Box width={'100%'}>
              <Skeleton variant="rectangle" height={60} />
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  width: '100%',
                  px: 1.75,
                  display: 'flex',
                  flexDirection: { xs: 'column', lg: 'row' },
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="body1" color="light-gray-text.main">
                  Replacement credit requested
                </Typography>

                <Typography variant="body1" color="dark-text.main">
                  {item.leave_credit.requested
                    ? item.leave_credit.requested === 1 || item.leave_credit.requested === 0
                      ? `${item.leave_credit.requested} day`
                      : `${item.leave_credit.requested} days`
                    : '0 day'}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  px: 1.75,
                  display: 'flex',
                  flexDirection: { xs: 'column', lg: 'row' },
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="body1" color="light-gray-text.main">
                  Replacement Credit Granted
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
                  <Typography variant="body1" color="dark-text.main">
                    {item.leave_credit.granted
                      ? item.leave_credit.granted === 1 || item.leave_credit.granted === 0
                        ? `${item.leave_credit.granted} day`
                        : `${item.leave_credit.granted} days`
                      : '0 day'}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  px: 1.75,
                  display: 'flex',
                  flexDirection: { xs: 'column', lg: 'row' },
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="body1" color="light-gray-text.main">
                  Replacement Credit Rejected
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
                  <Typography variant="body1" color="dark-text.main">
                    {item.leave_credit.rejected
                      ? item.leave_credit.rejected === 1 || item.leave_credit.rejected === 0
                        ? `${item.leave_credit.rejected} day`
                        : `${item.leave_credit.rejected} days`
                      : '0 day'}
                  </Typography>
                </Box>
              </Box>
            </>
          )}
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            rowGap: 1,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'gray-background.main',
              width: '100%',
              py: 0.5,
              px: 1.75,
              my: 2,
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" color="light-gray-text.main">
              Credit utilized
            </Typography>
          </Box>
          {isLoading ? (
            <Box width={'100%'}>
              <Skeleton variant="rectangle" height={60} />
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  width: '100%',
                  px: 1.75,
                  display: 'flex',
                  flexDirection: { xs: 'column', lg: 'row' },
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="body1" color="light-gray-text.main">
                  Utilized
                </Typography>

                <Typography variant="body1" color="dark-text.main">
                  {item.leave_credit.utilised
                    ? item.leave_credit.utilised === 1 || item.leave_credit.utilised === 0
                      ? `${item.leave_credit.utilised} day`
                      : `${item.leave_credit.utilised} days`
                    : '0 day'}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  px: 1.75,
                  display: 'flex',
                  flexDirection: { xs: 'column', lg: 'row' },
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="body1" color="light-gray-text.main">
                  Outstanding
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
                  <AdxStatusBar
                    status={{
                      text: 'Revocable',

                      bgColor: 'light-yellow-01.main',
                      color: 'yellow-02.main',
                    }}
                  />
                  <Typography variant="body1" color="dark-text.main">
                    {item.leave_credit.outstanding
                      ? item.leave_credit.outstanding === 1 || item.leave_credit.outstanding === 0
                        ? `${item.leave_credit.outstanding} day`
                        : `${item.leave_credit.outstanding} days`
                      : '0 day'}
                  </Typography>
                </Box>
              </Box>
            </>
          )}
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            rowGap: 1,
            mb: { xs: 2, lg: 0 },
          }}
        >
          <Box
            sx={{
              backgroundColor: 'gray-background.main',
              width: '100%',
              py: 0.5,
              px: 1.75,
              my: 2,
              borderRadius: 1,
            }}
          >
            <Typography variant="body2" color="light-gray-text.main">
              Applicable leave
            </Typography>
          </Box>
          <Box
            sx={{
              width: '100%',
              px: 1.75,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="body1" color="light-gray-text.main">
              The replacement leave credit will be used first for the following leaves.
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 2.5,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              rowGap: 2,
            }}
          >
            {/* Applicable leave array mapping */}
            {isLoading ? (
              <Box width={'100%'}>
                <Skeleton variant="rectangle" height={60} />
              </Box>
            ) : (
              <>
                {(item.applicable_leave || []).map(app => (
                  <Box
                    key={app.leave_policy_id}
                    sx={{
                      width: '100%',
                      px: 1.75,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      columnGap: 2,
                    }}
                  >
                    <Typography variant="body1" color="dark-text.main">
                      {app.leave_policy_name}
                    </Typography>
                  </Box>
                ))}
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default BalanceTypeReplacement
